import React from 'react';
import { connect } from 'react-redux';

import QuestionHOC from './QuestionHOC';

function DocumentQuestion({ index, item, questions, answers }) {
  const question = questions.find((option) => {
    return option.linkId === item.linkId
  });

  const answer = answers.find((answer) => {
    return answer.linkId === item.linkId
  });

  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">{answer ? Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer : '*Answer*'}</div>
    } else {
      return <>
        <div className="col-8">{question ? question.text : ''}</div>
        <div className="col-4">{answer ? Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer : '*Answer*'}</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}

const mapStateToProps = state => {
  return {
    questions: state.questionnaire.current.item,
    answers: state.questionnaire.answers
  }
}

export default connect(mapStateToProps)(DocumentQuestion);